module.exports = __webpack_public_path__ + "img/geofisica_9-16_1620.2495b1e2.webp";